import ExamRoom from './ExamRoom';

export default ExamRoom;
